export class MongoAtlasRestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clusterName",
            "baseName": "clusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "allowExistingCluster",
            "baseName": "allowExistingCluster",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
